import { EngineContext, Preset, ViewsEnum } from '@itero/engine-contracts';
import { JawsState } from '@models/interfaces/jaws.interfaces';

/**
 * Get is application in debug mode
 * @returns boolean
 */
export const getIsDebugMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('debug') === 'true';
};

/**
 * Get is application in automation mode
 * @returns boolean
 */
export const getIsAutomationMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('automation') === 'true';
};

/**
 * Set the cursor to crosshair when the caliper is active
 * @param domElement DOM element to set the cursor
 * @param cursorStryle CSS cursor style to apply
 * @returns void
 */
export const setCursorStyle = (domElement: HTMLElement | undefined | null, cursorStryle: string) => {
  if (domElement) {
    domElement.style.cursor = cursorStryle;
  }
};

/**
 * Retrieves the currently active jaw for the jaws navigation plugin based on the engine context.
 * Returns the active jaw as an ADASystem enum value.
 */
export const getCurrentJawNavigationActiveJaw = (engineContext: EngineContext): JawsState => {
  const jawsNavProps = engineContext.preset?.find((plugin: Preset) => plugin.component.id === 'JawsNavigation')
    ?.props as
    { upper_jaw?: { selected: boolean }; lower_jaw?: { selected: boolean }; bite?: { selected: boolean } } | undefined;
  const isBiteSelected = jawsNavProps?.bite?.selected;

  return {
    upper_jaw: !!(jawsNavProps?.upper_jaw?.selected || isBiteSelected),
    lower_jaw: !!(jawsNavProps?.lower_jaw?.selected || isBiteSelected),
  };
};

/**
 * Gets the current stage splitter views.
 * @param engineContext The engine context object.
 * @returns The number of views.
 */
export const getCurrentEngineViewsCount = (engineContext: EngineContext) => {
  const stageSplitterPlugin = (engineContext.preset ?? []).find(
    (plugin: Preset) => plugin.component.id === 'StageSplitter'
  );
  const currentViews = stageSplitterPlugin?.props?.activeView;
  switch (currentViews) {
    case ViewsEnum.SINGLE_VIEW:
      return 1;
    case ViewsEnum.DUAL_VIEW:
      return 2;
    case ViewsEnum.GALLERY_VIEW:
      return 5;
    default:
      return 1;
  }
};
